import { render } from "./PlayerPage.vue?vue&type=template&id=6f49c915&scoped=true"
import script from "./PlayerPage.vue?vue&type=script&lang=js"
export * from "./PlayerPage.vue?vue&type=script&lang=js"

import "./PlayerPage.vue?vue&type=style&index=0&id=6f49c915&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f49c915"]])

export default __exports__